/**
 * This file can be shared between production app code, storybook and cypress
 * because production app code, storybook and cypress should not import codes together directly.
 */
export const VOTING_OPTIONS_MENU = 'issue.fields.voters.dropdown';
export const VOTERS_UI_STYLED_BUTTON = 'issue-field-voters.ui.button.styled-button';
export const VOTERS_UI_NO_VOTES_ICON = 'issue-field-voters.common.vote-button-refresh.like-icon';
